import { SimpleJobDescription } from './SimpleJobDescription';
import { useViewjobProctorAllocation } from '../../../../../proctor/__generated__/ViewjobProctorContext';
import { MobVjJobSummaryTst } from '../../../../../proctor/__generated__/ViewjobProctorSpecifications';
import { useViewjobOneGraphModel } from '../../../../context/ViewJobDataContext';
import { VJNegativeSpacing } from '../../ProfileInsights/components/common/VJNegativeSpacing';

import React, { Fragment } from 'react';

export type JobDescriptionProps = {
    /**
     * The Job Description which can contain HTML elements.
     */
    jobDescription: string | undefined;
};

export const JobDescription = (props: JobDescriptionProps) => {
    if (props.jobDescription) {
        return <SimpleJobDescription jobDescription={props.jobDescription} />;
    }

    return <></>;
};

type OGWrapperOmitKeys = 'jobDescription';
export interface OGWrappedJobDescriptionProps
    extends Omit<JobDescriptionProps, OGWrapperOmitKeys> {}

export function OGWrappedJobDescription({}: OGWrappedJobDescriptionProps) {
    const ogModel = useViewjobOneGraphModel();
    const mobVjJobSummaryTstActive = useViewjobProctorAllocation(MobVjJobSummaryTst).value > 0;

    if (ogModel == null) {
        return null;
    }

    return (
        <Fragment>
            <JobDescription jobDescription={ogModel.job?.jobDescription} />
            {mobVjJobSummaryTstActive && <VJNegativeSpacing hasDivider={true} />}
        </Fragment>
    );
}
